<template>
  <div class="app-nav is-dark level">
    <div class="level-left">
      <a class="button" @click="goToApps">
        <span class="icon is-small">
          <i class="material-icons">&#xE317;</i>
        </span>
        <span>{{ $t('apps.nav.back') }}</span>
      </a>
      <div class="app-id">{{ $t('apps.nav.app_id') }}: {{ appId }}</div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'AppNav',

  computed: {
    ...mapState('application', ['appId']),

    activeRoute() {
      return this.$route.name;
    },
  },

  methods: {
    goToApps() {
      return this.$router.push({ name: 'apps' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.hide-navbar .app-nav {
  display: none;
}

.app-nav {
  position: relative;
  display: flex;
  align-items: center;
  height: 2.5rem;

  margin-bottom: 0;
  box-shadow: 0 2px 12px 0 rgba($black, 0.06);
  padding-left: 3rem;
  padding-right: 3rem;

  &.is-dark {
    background-color: $black-quater;
  }
}

.button {
  background-color: $white-ter;
  padding: 0.6875rem 1.125rem;
  font-size: 0.6875rem;
  line-height: 1.125rem;
  letter-spacing: 2.3px;
  font-weight: 500;
  text-transform: uppercase;
  color: rgba($black, 0.87);
  border-radius: 0;
  border-left: 1px solid rgba($black, 0.08);
  border-right: 1px solid rgba($black, 0.08);

  .icon {
    font-size: 1rem;

    &:first-child {
      &:not(:last-child) {
        margin-left: 0;
        margin-right: 0.75rem;
      }
    }
  }
}

.app-id {
  color: rgba($white, 0.72);
  font-size: 0.875rem;
  margin-left: 1.5rem;
}
</style>
